import React, { FC } from 'react';
import { useRestrictedModal } from '../../../../components/modal/useRestrictedModal';
import { Hyperlink } from '../../../../components/Hyperlink';
import styles from './entity_list_link_title.module.scss';
import { useUser } from '../../../../user/useUser';

type Props = {
  entityId: string;
  entityUrl: string;
  entityName: string;
  source: string;
};

export const EntityListLinkTitle: FC<Props> = ({
  entityId,
  entityName,
  entityUrl,
  source,
}) => {
  const {
    accessPremium,
    currentUser: { isSnapshotsCrawler },
  } = useUser();
  const { openRestrictedModal } = useRestrictedModal();
  const props =
    accessPremium || isSnapshotsCrawler
      ? {
          href: entityUrl,
          source,
        }
      : {
          onClick: () => openRestrictedModal({ source }),
        };
  return (
    <Hyperlink
      className={styles.title}
      data-doctrine-popover
      data-lawyer={entityId}
      {...props}
    >
      {entityName}
    </Hyperlink>
  );
};
